import { render, staticRenderFns } from "./FinancialStatements.vue?vue&type=template&id=bc8ff62e&"
import script from "./FinancialStatements.vue?vue&type=script&lang=js&"
export * from "./FinancialStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports